import { useEffect, useState } from "react";
import styles from "./Home.module.scss";
import { DashboardHeader, GetCash } from "../../components";
import ServicesAPI from "../../services/services";
import { storeEMITenure, storeLeadID, storeProductId, storeProductType } from "../../utils/storage";
import LoanRepayment from "../../components/GetCash/LoanRepayment";
import { useDispatch, useSelector } from "react-redux";
import { addAccountId, changeLoanApproved } from "../../redux/slices/userSlice";
import { storeCustomerTypeAndAppVersion } from "../../lib/script";
import FeedbackDrawer from "../../components/FeedbackDrawer/FeedbackDrawer";
import { fetchCredeauData } from "../../lib/credlibkit";

// import { getCustomerID } from "../../utils/storage";
import EMIRepayment from "../../components/GetCash/EMIRepayment";
import { googleEvent_HOM001 } from "../../lib/google-analytics";
import { useNavigate } from "react-router-dom";

const packageJson = require("../../../package.json");

export default function Home() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [openFeedback, setOpenFeedback] = useState(false);
  const { user, isLoanApproved } = useSelector((state) => state.user);

  const { isFeedbackRequired } = data || {};
  const dispatch = useDispatch();

  const { dashboardAPI } = new ServicesAPI();

  const navigate = useNavigate();

  // Redirect User if status is not in the excluded list
  const excludedStatuses = ["Settlement", "Disbursed", "Closed", "Part Payment", "Blacklisted"];

  const fetchAPI = async () => {
    const res = await dashboardAPI();

    if (res && res.statusCode === 200) {
      if (res.data.showStepDashboardMessages && Object.keys(res?.data?.step).length > 0) {
        const originalData = res.data;
        const stepData = res.data.step;
        setData({ ...originalData, ...stepData });
      } else {
        setData(res.data);
      }

      const leadID = res?.data?.lead?.leadID;

      if (leadID) {
        storeLeadID(leadID);
      } else {
        storeLeadID("");
      }

      // Store Customer Type & App Version
      storeCustomerTypeAndAppVersion(res?.data?.customer_type, packageJson.version);

      localStorage.setItem("salaryDate", res?.data?.salaryDate);

      // Redirect User

      // if (excludedStatuses.includes(res?.data?.lead?.status)) {
      //   console.log("Not redirecting user");
      // } else if (res?.data?.lead?.status === "Approved Process") {
      //   dispatch(changeLoanApproved(true));
      //   navigate("/select-loan");
      // } else {
      //   navigate(res?.data?.step?.current_route ?? "/home");
      // }

      // Credeau SDK
      fetchCredeauData(localStorage.getItem("custId"));
      storeProductId(res?.data?.productId);
      storeEMITenure(res?.data?.noOfEMIs);
      storeProductType(res.data.product_type);
    }
    setLoading(false);
  };

  useEffect(() => {
    dispatch(addAccountId(""));
    fetchAPI();

    // Events
    googleEvent_HOM001();
  }, []);

  useEffect(() => {
    setOpenFeedback(isFeedbackRequired);
  }, [isFeedbackRequired]);

  return (
    <>
      <DashboardHeader />

      <div className={styles.home}>
        {/* {data?.lead?.status === "Disbursed" || data?.lead?.status === "Part Payment" ? (
          <LoanRepayment data={data} />
        ) : (
          <GetCash data={data} />
        )} */}

        {(data?.lead?.status === "Disbursed" && data.isActuallyDisbursed) || data?.lead?.status === "Part Payment" ? (
          <>{data?.productId === 2 ? <LoanRepayment data={data} /> : <EMIRepayment />}</>
        ) : (
          <GetCash data={data} />
        )}

        {/* Our Process */}
        <div className={styles.our__process}>
          <div>
            <img src="/images/no-hidden-charge.png" alt="" />
            <p>
              No Hidden <br /> Charges
            </p>
          </div>
          <div>
            <img src="/images/quick-disbursal.png" alt="" />
            <p>
              Quick <br /> Disbursed
            </p>
          </div>
          <div>
            <img src="/images/simple-process.png" alt="" />
            <p>
              Simple & <br /> Secure Process
            </p>
          </div>
        </div>
      </div>

      {isFeedbackRequired ? (
        <FeedbackDrawer
          openFeedback={openFeedback}
          setOpenFeedback={setOpenFeedback}
          onClose={() => setOpenFeedback(false)}
          user={user}
          onFeedbackSubmit={() => {
            fetchAPI();
          }}
        />
      ) : null}
    </>
  );
}
